import axios from "axios";
import { ethers } from "ethers";
// import detectEthereumProvider from "@metamask/detect-provider";
import ToastService from "./ToastService";
import { DataService } from "./DataService";
import { keccak256, solidityKeccak256 } from "ethers/lib/utils";
import { MerkleTree } from "merkletreejs";

export class ContractService {
  private provider: any;
  private signer: any;
  private contract: any;
  private slimeShadiesSolidity: any;
  private _dataService = new DataService();

  setUpContract = async () => {
    if (!this.contract) await this.getContract();
    return this.setProviderData();
  };
  sendConnectionRequest = async () => {
    try {
      this.provider = new ethers.providers.Web3Provider(
        (window as any).ethereum
      );
      const isDevelopmentMode =
        process.env.REACT_APP_WEBGL_RESOURCE_KEY !== "Prod";

      const chain = isDevelopmentMode
        ? {
            chainId: "0xA869",
            rpcUrls: ["https://api.avax-test.network/ext/bc/C/rpc"],
            chainName: "Avalanche FUJI C-Chain",
          }
        : {
            chainId: "0xA86A",
            rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
            chainName: "Avalanche Mainnet C-Chain",
          };

      (window as any).ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            // chainId: "0xA868",
            // rpcUrls: ["http://192.168.1.62:9650/ext/bc/C/rpc"],
            // chainName: "Local Avax",

            ...chain,
            nativeCurrency: {
              name: "AVAX",
              symbol: "AVAX",
              decimals: 18,
            },
            blockExplorerUrls: ["https://snowtrace.io/"],
          },
        ],
      });

      (window as any).ethereum.on("chainChanged", () => {
        localStorage.removeItem("spicaToken");
        localStorage.removeItem("spicaUserId");
        window.location.reload();
      });

      (window as any).ethereum.on("accountsChanged", () => {
        localStorage.removeItem("spicaToken");
        localStorage.removeItem("spicaUserId");
        window.location.reload();
      });
    } catch (error) {
      console.log("missing provider");
      return;
    }
    return this.provider.send("eth_requestAccounts", []);
  };

  getContract = async () => {
    // this.contract = deploymentLocal;
    // return deploymentLocal;

    const conf = await this._dataService.resources.Config.getAll({
      queryParams: { filter: { key: process.env.REACT_APP_CONTRACT_TYPE } },
    })
      .then((data) => data[0])

      .catch((e) => console.log("e :", e));

    if (!conf) {
      return {};
    }
    const deploymentFji = await axios.get(
      conf.file?.replace("/download", "") as any
    );
    this.contract = deploymentFji.data;
    return deploymentFji.data;
  };

  setProviderData = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        this.provider = new ethers.providers.Web3Provider(
          (window as any).ethereum
        );
      } catch (error) {
        ToastService.error("Missing Provider!");
        reject(false);
        return;
      }
      this.signer = this.provider.getSigner();
      await this.getSolidity().catch((e: any) => {
        ToastService.error("Something went wrong on solidity side!");
        reject(false);
      });
      resolve(true);
    });
  };

  getSolidity = async () => {
    this.slimeShadiesSolidity = new ethers.Contract(
      this.contract.contracts.SlimeShadiesGameContract.address,
      this.contract.contracts.SlimeShadiesGameContract.abi,
      this.provider
    );
  };
  getSolidities = () => {
    return {
      SlimeShadiesSolidity: this.slimeShadiesSolidity,
    };
  };
  getSigner = () => {
    return this.signer;
  };
  parseEther = (value: string) => {
    return ethers.utils.parseEther(value);
  };
  formatEther = (value: string) => {
    return ethers.utils.formatEther(value);
  };

  getContractJson = () => {
    return this.contract;
  };
  getConnectedContract = (connectedContract: any) => {
    return connectedContract.connect(this.signer);
  };
  getMinter = () => {
    return "0xecde74914988d394964746bb15b9a9ff86107642";
  };
  getProvider = () => {
    return this.provider;
  };

  // addToken = async (
  //   tokenAddress: any,
  //   tokenSymbol: any,
  //   tokenDecimals: any
  // ) => {
  //   const providerEth: any = await detectEthereumProvider();
  //   new ethers.providers.Web3Provider((window as any).ethereum);
  //   await providerEth.sendAsync(
  //     {
  //       method: "metamask_watchAsset",
  //       params: {
  //         type: "ERC20",
  //         options: {
  //           address: tokenAddress,
  //           symbol: tokenSymbol,
  //           decimals: tokenDecimals,
  //         },
  //       },
  //       id: Math.round(Math.random() * 100000),
  //     },
  //     (err: any, added: any) => {
  //       if (err || "error" in added) {
  //         ToastService.error("There was a problem while adding the token!");
  //         return;
  //       }
  //     }
  //   );
  // };
  // addWisltoMetamask = async () => {
  //   await this.addToken(this.getSolidities().SlimeShadiesSolidity.address, "WISL", 18);
  // };

  handleErrorMessage = (errMessage: any) => {
    return errMessage.data
      ? errMessage.data.message
      : errMessage.message.split(":")[errMessage.message.split(":").length - 1];
  };
  createProofData = (address: string, ethAmount: number): string => {
    return solidityKeccak256(
      ["address", "uint256"],
      [address, this.parseEther(ethAmount.toString())]
    );
  };
  createMerkleTree = (treeData: { wallet: string; amount: number }[]) => {
    const merkleData: any = [];

    treeData.forEach((item, i) => {
      merkleData.push(
        solidityKeccak256(
          ["address", "uint256"],
          [item.wallet, this.parseEther(item.amount.toString())]
        )
      );
    });

    const merkleTree = new MerkleTree(
      merkleData,
      (data: any) => keccak256(data).slice(2),
      {
        sort: true,
      }
    );
    return merkleTree;
  };
}

export default new ContractService();
